module.exports = __webpack_public_path__ + "img/P3-YUN.0009a5d8.svg";